import { PropsWithChildren, FC } from 'react'
import { Row, Col } from 'antd'
import { AddFollowerType } from '@OpsQuality/types'

import Box from '~/core/Box'

import DeleteFollower from './DeleteFollower'
import followersStyle from './AddFollowers/styles.css'
import styles from './styles.css'
import FollowersStaticText from './FollowersStaticText'

type CurrentFollowersType = {
    currentFollower: AddFollowerType
    key: number
    handleRemove: (id: number) => void
    undoRemove: (id: number) => void
}

const CurrentFollower: FC<PropsWithChildren<CurrentFollowersType>> = ({
    currentFollower,
    handleRemove,
    undoRemove,
}) => {
    return (
        <Row className={followersStyle.currentItems}>
            <Col sm={18}>{currentFollower.followerName}</Col>
            <Col sm={6} style={{ textAlign: 'right' }}>
                {currentFollower.assigned ||
                currentFollower.isChannel ||
                !currentFollower.canDelete ? (
                    <FollowersStaticText
                        assignedDri={currentFollower.assigned}
                        isChannel={currentFollower.isChannel}
                    />
                ) : (
                    <Box className={styles.deleteIcon}>
                        {currentFollower.id && currentFollower.canDelete && (
                            <DeleteFollower
                                id={currentFollower.id}
                                isDelete={currentFollower.delete}
                                isAdded={currentFollower.isAdded}
                                handleRemove={handleRemove}
                                handleUndoRemove={undoRemove}
                            />
                        )}
                    </Box>
                )}
            </Col>
        </Row>
    )
}

export default CurrentFollower
